import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "../../shadcn/ui/card";
import { Button } from "../../shadcn/ui/button";
import { Mail } from "lucide-react";

const ConfirmInvite = () => {
  return (
    <div className="w-full max-w-md mx-auto px-4">
      <Card className="border-0 shadow-2xl">
        <CardHeader className="space-y-1">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
              <Mail className="w-10 h-10 text-blue-600" />
            </div>
          </div>
          <CardTitle className="text-2xl font-semibold text-center">Thank You!</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-gray-600 text-center">
            Check your email for the verification link to finish setting up your account.
          </p>
        </CardContent>
        <CardFooter className="flex flex-col space-y-4">
          <Button asChild className="w-full">
            <Link to="/signin">Go to Sign In</Link>
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default ConfirmInvite;
